module.exports = "<div *ngIf=\"user\" class=\"logout\">\n  <div class=\"user-name\">\n    {{user.name}}\n  </div>\n  <button class=\"btn btn-secondary\" (click)=\"logout()\">Logout</button>\n</div>\n\n<div *ngIf=\"!user\" class=\"loading-screen\">\n  <button class=\"btn btn-login\" (click)=\"login()\">Login</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/navigation.component.html
// module id = ./src/app/templates/navigation.component.html
// module chunks = 0